/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Svelte and other libraries. It is a great starting point when
 * building robust, powerful web applications using Svelte and Laravel.
 *
 * require('./bootstrap');
 */
import Search from "./components/search.svelte";
import SearchList from "./components/searchList.svelte";
import counterUp from "counterup2";
//require("waypoints/lib/noframework.waypoints.js");

/**
 * Counter
 */
const achievementsElements =
    document.getElementsByClassName("achievements_value");
const searchElement = document.getElementById("js-search");
const searchListElement = document.getElementById("js-search-list");
const arrowRightElement = document.getElementsByClassName("arrow-next");

if (arrowRightElement) {
    var counter = 0;
    var intervalID = setInterval(() => {
        if (counter < arrowRightElement.length) {
            arrowRightElement[counter++].click();
        } else {
            counter = 0;
        }
    }, 6000);
}

if (achievementsElements) {
    const callback = (entries) => {
        entries.forEach((entry) => {
            const el = entry.target;
            if (entry.isIntersecting && !el.classList.contains("is-visible")) {
                counterUp(el, {
                    duration: 1500,
                    delay: 5,
                });
                el.classList.add("is-visible");
            }
        });
    };

    const IO = new IntersectionObserver(callback, { threshold: 1 });
    Array.from(achievementsElements).forEach((element) => {
        IO.observe(element);
    });
}

if (searchElement) {
    const search = new Search({
        target: searchElement,
    });

    searchListElement.innerHTML = "";

    const searchList = new SearchList({
        target: searchListElement,
    });

    window.search = search;
    window.searchList = searchList;
}
//export default { search, searchList };
